function Contact() {
  return (
    <>
      <div
        className="container col-xxl-8 px-4 py-5"
        style={{ height: "100vh", marginTop: "58px" }}
      >
        <div className="card px-4 py-5 my-3 text-center">
          <div className="row g-0">
            <h4 className="text-secondary">
              For any questions or comments about Young Life in the Mountain
              State or about the 49 Plan, contact:
            </h4>
            <div className="col-md-6">
              <img
                className="img-fluid rounded-start"
                src="staff-pictures/scott.jpg"
                alt="Staff Person"
              />
            </div>
            <div className="col-md-6">
              <div className="card-body">
                <h3 className="card-title text-secondary">
                  Scott Berg, Regional Director,
                  <br /> Young Life Mountain State
                </h3>
                <h4 className="card-text text-secondary">
                  POB 483 <br />
                  Mt Nebo, WV 26679.
                  <br />
                  scottberg@wv.younglife.org
                </h4>
                <h5 className="card-text text-secondary">304-880-6174</h5>
              </div>
              <div className="mt-5">
                <a
                  href="http://giving.younglife.org/mountainstate"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="btn btn-primary btn-sm col-sm-8 my-2 text-secondary"
                >
                  Give to the county in the Mountain State with the greatest
                  financial need
                </a>
                <a
                  href="https://giving.younglife.org/49plan"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="btn btn-primary btn-sm  col-sm-8 my-2 text-secondary"
                >
                  Vist Young Life's website
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="card px-4 py-5 my-3 text-center">
          <div className="row">
            <h5 className="text-secondary">
              Interested in receiving Mountain State YL prayer updates via
              email?
            </h5>
            <a
              href="https://app.e2ma.net/app2/audience/signup/65924/38072.646552760/"
              target="_blank"
              rel="noreferrer noopener"
              className="btn btn-primary btn-sm  col-sm-3 mx-auto my-2 text-secondary"
            >
              Sign Up
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
